export default __webpack_public_path__ + "static/media/map-marker.aa98ad0e.svg";